import React from "react";
import { Smartphone, LogOut } from "lucide-react";
import Mascot from "@/components/Mascot";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/i18n/I18nContext";

// Shown to CLIENT accounts that open the web app in a browser — the client
// experience lives exclusively in the native iPhone app. Admin & coach
// accounts keep full web access (routing handled in App.js ProtectedRoute).
export const MobileOnlyNotice = () => {
  const { logout } = useAuth();
  const { t } = useT();
  return (
    <div className="min-h-screen bg-[#EAF1F0] flex flex-col items-center justify-center px-8 text-center" data-testid="mobile-only-notice">
      <Mascot size={128} pose="bounce" />
      <div className="mt-6 h-12 w-12 rounded-full bg-[#5A8B8F]/15 flex items-center justify-center">
        <Smartphone className="h-6 w-6 text-[#2C5254]" />
      </div>
      <h1 className="mt-4 font-heading text-2xl font-semibold text-[#2C5254]">
        {t("webGate.title")}
      </h1>
      <p className="mt-2 text-sm text-slate-600 max-w-xs leading-relaxed">
        {t("webGate.body")}
      </p>
      <button
        type="button"
        onClick={logout}
        data-testid="mobile-only-logout-btn"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-white shadow-sm border border-slate-200 px-5 py-2.5 text-sm font-semibold text-[#2C5254] active:scale-95 transition"
      >
        <LogOut className="h-4 w-4" />
        {t("common.logout")}
      </button>
    </div>
  );
};

export default MobileOnlyNotice;
